/* GERADO por scripts/relayout/81-lp-v3.py (lp/v3/src/js): base + rua */
(() => {
/* ---------- Ajudantes de escopo: o build prefixa classes (z3-) e ids (zlp3-) no HTML e no CSS; aqui o JS faz o mesmo ---------- */
const R = document.getElementById('zlp3');
const D = JSON.parse(document.getElementById('zlp3-d').textContent);
const S = (sel) => sel.replace(/\.(-?[_a-zA-Z][\w-]*)/g, '.z3-$1').replace(/#([_a-zA-Z][\w-]*)/g, '#zlp3-$1');   // seletor
const $ = (sel, c = R) => c.querySelector(S(sel));
const $$ = (sel, c = R) => [...c.querySelectorAll(S(sel))];
const I = (id) => document.getElementById('zlp3-' + id);
const C = (n) => 'z3-' + n;                                                                                       // classe
const H = (html) => html                                                                                          // HTML montado no JS
  .replace(/\bclass="([^"]*)"/g, (m, v) => 'class="' + v.split(/\s+/).filter(Boolean).map(C).join(' ') + '"')
  .replace(/\b(id|for)="([^"]+)"/g, (m, a, v) => `${a}="zlp3-${v}"`)
  .replace(/\bhref="#([^"]+)"/g, 'href="#zlp3-$1"');
const folha = (tipo) => (D.folhas || []).find(f => f.tipo === tipo);
const modal = (tipo) => (D.modais || []).find(f => f.tipo === tipo);
const RM = matchMedia('(prefers-reduced-motion: reduce)');
const DESK = matchMedia('(min-width: 900px)');
const fmt = (x) => String(Math.round(x * 10) / 10).replace('.', ',');
/* Modal "Seu pet cabe?" sem ficha (sem medida/peso confiável no cadastro): NÃO calcula. Junta o que o cliente preencheu e manda ao WhatsApp.
   Campos, rótulos e mensagens vêm do JSON (modal.campos, aria_sp, msg0/msg1, res0/res1, why0). esp = () => rótulo da espécie escolhida (opcional). */
const semFicha = (M) => !M.ficha || M.modo === 'whatsapp';
const numCampo = (el) => { const s = el.value.trim().replace(',', '.'); const x = parseFloat(s); return s && isFinite(x) && x > 0 ? x : null; };
function modalWa(M, esp) {
  const campos = M.campos.map(c => [c, I(c.id)]), lv = I('fitLv'), why = I('fitWhy'), wa = I('fitWa'), res = I('fitRes'), altBox = I('fitAlt');
  return () => {
    const vals = campos.map(([c, el]) => [c, numCampo(el)]).filter(x => x[1]);
    const nome = esp && esp();
    const linhas = (nome && M.aria_sp ? [`${M.aria_sp}: ${nome}`] : []).concat(vals.map(([c, v]) => `${c.label}: ${fmt(v)} ${c.un}`));
    delete res.dataset.lv; altBox.hidden = true; altBox.innerHTML = '';
    lv.textContent = vals.length ? (M.res1 || M.res0) : M.res0;
    why.innerHTML = vals.length ? linhas.map(t => `<li>${t}</li>`).join('') : `<li>${M.why0}</li>`;
    wa.href = `https://wa.me/${D.whatsapp}?text=${encodeURIComponent(vals.length ? `${M.msg1}\n${linhas.join('\n')}` : M.msg0)}`;
  };
}
const ar = (s) => { const [w, h] = String(s).split('/').map(Number); return w / h; };

/* ---------- Anatomia com chamadas e linha-guia (pinos x,y em % da foto; rótulo em lx,ly) ---------- */
(() => {
  const svg = I('coSvg'); if (!svg) return;
  const an = folha('anatomia'), im = D.img[an.img], W = im.w, H0 = im.h, ns = 'http://www.w3.org/2000/svg';
  const lbl = I('coLbl'), leg = I('legend');
  an.pinos.forEach((c, i) => {
    const px = c.x / 100 * W, py = c.y / 100 * H0, ex = c.lx / 100 * W, ey = c.ly / 100 * H0;
    const kx = c.r ? Math.max(px + 40, ex - 160) : Math.min(px - 40, ex + 160);
    const pl = document.createElementNS(ns, 'polyline');
    pl.setAttribute('points', `${px},${py} ${kx},${ey} ${ex},${ey}`); pl.setAttribute('pathLength', '1');
    pl.style.transitionDelay = (i * 0.12) + 's';
    const ring = document.createElementNS(ns, 'circle'); ring.setAttribute('class', C('ring')); ring.setAttribute('cx', px); ring.setAttribute('cy', py); ring.setAttribute('r', 11);
    const dot = document.createElementNS(ns, 'circle'); dot.setAttribute('class', C('dot')); dot.setAttribute('cx', px); dot.setAttribute('cy', py); dot.setAttribute('r', 4);
    svg.append(pl, ring, dot);
    const d = document.createElement('div'); d.className = C('lbl') + (c.r ? ' ' + C('r') : '');
    d.style.left = c.lx + '%'; d.style.top = c.ly + '%'; d.style.transitionDelay = (0.7 + i * 0.12) + 's';
    d.innerHTML = `${c.t}<small>${c.s}</small>`; lbl.append(d);
    const n = document.createElement('span'); n.className = C('num'); n.textContent = i + 1; n.style.left = c.x + '%'; n.style.top = c.y + '%'; lbl.append(n);
    const li = document.createElement('li'); li.innerHTML = `<i>${i + 1}</i><span>${c.m || c.t}</span>`; leg.append(li);
  });
  const plate = I('plate');
  new IntersectionObserver((es, o) => es.forEach(e => {
    if (e.isIntersecting) { plate.classList.add(C('drawn')); o.disconnect(); }
  }), { threshold: 0.35 }).observe(plate);
})();

/* ---------- Visualizador (desenho técnico e "por que importa") ---------- */
const viewer = I('viewer'), vs = I('vscroll'), vimg = I('vimg');
let lastFocus = null;
const openViewer = (src, a, alt) => {
  lastFocus = document.activeElement;
  vimg.src = src; vimg.alt = alt; vs.style.setProperty('--ar', a); vs.classList.remove(C('z')); viewer.showModal();
};
if (I('openBp')) I('openBp').onclick = () => {
  const b = I('openBp'), mob = matchMedia('(max-width:759px)').matches;
  openViewer(mob ? b.dataset.m : b.dataset.d, ar(mob ? b.dataset.arm : b.dataset.ard), b.dataset.alt);
};
if (I('openFis')) I('openFis').onclick = () => { const b = I('openFis'); openViewer(b.dataset.src, ar(b.dataset.ar), b.dataset.alt); };
I('vClose').onclick = () => viewer.close();
viewer.addEventListener('click', e => { if (e.target === viewer) viewer.close(); });
viewer.addEventListener('close', () => lastFocus && lastFocus.focus());
vimg.onclick = (e) => {
  const r = vimg.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
  vs.classList.toggle(C('z'));
  if (vs.classList.contains(C('z'))) requestAnimationFrame(() => {
    vs.scrollLeft = fx * vs.scrollWidth - vs.clientWidth / 2; vs.scrollTop = fy * vs.scrollHeight - vs.clientHeight / 2;
  });
};

/* ---------- Carrossel genérico (gestos e perguntas) ---------- */
function carousel({ track, items, prev, next, count, bar, onIndex }) {
  let cur = 0;
  const n = items.length;
  const idxNow = () => {
    const max = track.scrollWidth - track.clientWidth;
    return max > 0 ? Math.round(track.scrollLeft / max * (n - 1)) : 0;
  };
  const paint = (i) => {
    cur = i;
    count.textContent = `${i + 1}/${n}`;
    bar.style.transform = `scaleX(${(i + 1) / n})`;
    prev.disabled = i === 0; next.disabled = i === n - 1;
    onIndex && onIndex(i);
  };
  const go = (i) => {
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: RM.matches ? 'auto' : 'smooth' });
    paint(i);
  };
  let raf = 0;
  track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = idxNow(); if (i !== cur) paint(i); }); }, { passive: true });
  prev.addEventListener('click', () => go(cur - 1));
  next.addEventListener('click', () => go(cur + 1));
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
  });
  paint(0);
  return { go, get i() { return cur; } };
}

// Gestos: carrossel no celular, foto fixa que troca no desktop
if (I('steps')) {
  const steps = $$('.step'), gImgs = $$('.g-fig img'), nS = steps.length;
  const gN = I('gN'), gP = I('gP');
  const setStep = (i) => {
    steps.forEach((s, k) => s.classList.toggle(C('on'), k === i));
    gImgs.forEach((im, k) => im.classList.toggle(C('on'), k === i));
    gN.textContent = `Passo ${i + 1} de ${nS}`; gP.parentElement.style.setProperty('--p', (i + 1) / nS);
  };
  carousel({ track: I('steps'), items: steps, prev: I('gPrev'), next: I('gNext'),
    count: I('gCount'), bar: I('gBar'), onIndex: (i) => { if (!DESK.matches) setStep(i); } });
  const stepIO = new IntersectionObserver((es) => {
    if (!DESK.matches) return;
    es.forEach(e => { if (e.isIntersecting) setStep(steps.indexOf(e.target)); });
  }, { rootMargin: '-45% 0px -45% 0px' });
  steps.forEach(s => stepIO.observe(s));
}

// Perguntas: carrossel no celular, índice no desktop
if (I('track')) {
  const idxBtns = $$('#qIdx button');
  const qc = carousel({ track: I('track'), items: $$('.qc'), prev: I('qPrev'), next: I('qNext'),
    count: I('qCount'), bar: I('qBar'),
    onIndex: (i) => idxBtns.forEach((b, k) => b.setAttribute('aria-current', String(k === i))) });
  idxBtns.forEach((b, k) => b.addEventListener('click', () => qc.go(k)));
}

/* ---------- Cor: estado único, compartilhado por bloco de cores, comparativo e palco ---------- */
const COR = Object.fromEntries((D.cores || []).map(c => [c.k, c]));
let cor = R.querySelector('img[data-cor].z3-on')?.dataset.cor || (D.cores && D.cores[0] && D.cores[0].k);
$$('[data-sw]').forEach(g => {
  g.innerHTML = H(Object.entries(COR).map(([k, c]) =>
    `<button class="sw" type="button" role="radio" data-k="${k}" aria-label="${c.curto || c.nome}" aria-checked="${k === cor}" tabindex="${k === cor ? 0 : -1}" style="--c:${c.hex}"><i></i></button>`).join(''));
  g.addEventListener('click', e => { const b = e.target.closest(S('.sw')); if (b) setCor(b.dataset.k); });
  g.addEventListener('keydown', e => {
    const ks = Object.keys(COR), d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!d) return;
    e.preventDefault();
    const k = ks[(ks.indexOf(cor) + d + ks.length) % ks.length];
    setCor(k); g.querySelector(`[data-k="${k}"]`).focus();
  });
});
function setCor(k) {
  if (k === cor) return;
  cor = k;
  $$('.sw').forEach(b => { const on = b.dataset.k === k; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1; });
  $$('img[data-cor]').forEach(im => { if (im.dataset.cor === k) im.loading = 'eager'; im.classList.toggle(C('on'), im.dataset.cor === k); });
  $$('[data-cor-nome]').forEach(el => { el.textContent = el.closest(S('.stage')) ? (COR[k].curto || COR[k].nome) : COR[k].nome; });
  kick();
}
if (I('pickCor')) I('pickCor').onclick = () => I('oferta').scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth' });
// shortcut: o CTA rola até a compra da PDP (topo); se a PDP ganhar âncora própria do formulário, apontar para ela
if (I('buy')) I('buy').onclick = () => window.scrollTo({ top: 0, behavior: RM.matches ? 'auto' : 'smooth' });

/* ---------- Palco: entrada com spring (damping .86, response .55 s), interrompível ---------- */
const obj = I('obj');
const SP = { k: Math.pow(2 * Math.PI / 0.55, 2), c: 4 * Math.PI * 0.86 / 0.55 };
let p = 1, v = 0, target = 1, running = false, last = 0;
const render = () => {
  const q = Math.max(0, p);
  obj.style.transform = `translate3d(0,${(1 - q) * 56}px,0) scale(${0.93 + 0.07 * q})`;
  obj.style.opacity = Math.min(1, q * 1.5);
};
const tick = (t) => {
  const dt = Math.min(0.032, (t - last) / 1000 || 0.016); last = t;
  v += (-SP.k * (p - target) - SP.c * v) * dt; p += v * dt;   // parte do valor atual: nunca salta
  render();
  if (Math.abs(p - target) < 0.0005 && Math.abs(v) < 0.0005) { p = target; v = 0; render(); running = false; return; }
  requestAnimationFrame(tick);
};
const run = () => { if (!running) { running = true; last = performance.now(); requestAnimationFrame(tick); } };
function kick() { if (RM.matches || !obj) return; v -= 0.9; run(); }   // troca de cor: leve respiro do objeto
if (obj && !RM.matches) {
  const r = obj.getBoundingClientRect();
  if (r.top > innerHeight) { p = 0; render(); }
  new IntersectionObserver((es, o) => es.forEach(e => {
    if (e.isIntersecting) { target = 1; run(); o.disconnect(); }
  }), { threshold: 0.2 }).observe(obj);
}

/* ---------- Anatomia (pinos numerados + ficha) e tamanhos por colunas declaradas (régua de faixas, modal "Seu pet cabe?" com os campos do JSON) ---------- */
(() => {
  const an = I('an'), M = modal('cabe'), T = folha('tamanhos'); if (!an || !T) return;
  const pinos = I('anPins'), spec = I('anSpec');
  folha('anatomia').pinos.forEach((c, i) => {
    const n = document.createElement('span'); n.className = C('num'); n.textContent = i + 1;
    n.style.left = c.x + '%'; n.style.top = c.y + '%'; n.style.transitionDelay = (i * 0.12) + 's'; pinos.append(n);
    const li = document.createElement('li'); li.innerHTML = `<i>${i + 1}</i><div><b>${c.t}</b><span>${c.s}</span></div>`; spec.append(li);
  });
  new IntersectionObserver((es, o) => es.forEach(e => { if (e.isIntersecting) { an.classList.add(C('drawn')); o.disconnect(); } }), { threshold: 0.3 }).observe(an);

  const TAM = T.tam || [], T0 = (s, v) => s.replace(/\{(\w+)\}/g, (m, k) => v[k]);
  const lim = (x) => Array.isArray(x) ? x[1] : x;
  const dentro = (v, [a, b]) => v >= a && v <= b;
  // régua de faixas só com faixa numérica min–max (T.grafico {k, eixo, passo}; legado: T.eixo/T.passo sobre "peito")
  const G = T.grafico || (T.eixo && { k: 'peito', eixo: T.eixo, passo: T.passo });
  const faixaOk = !!G && TAM.some(s => Array.isArray(s[G.k]) && s[G.k][0] < s[G.k][1]);
  const AX = faixaOk ? G.eixo : [0, 1], un = ((T.colunas || []).find(c => c.k === (G && G.k)) || {}).un || 'cm';
  const pct = (v) => (Math.max(AX[0], Math.min(AX[1], v)) - AX[0]) / (AX[1] - AX[0]) * 100;
  const ticks = []; if (faixaOk) for (let v = AX[0]; v <= AX[1]; v += G.passo || 4) ticks.push(v);
  $$('[data-chart]').forEach(ch => {
    if (!faixaOk) return ch.remove();
    ch.innerHTML = H(TAM.map(s => { const [a, b] = s[G.k]; return `<div class="srow"><b>${s.t}</b><div class="trk"><span class="sb" data-t="${s.t}" style="left:${pct(a)}%;width:${pct(b) - pct(a)}%">${fmt(a)}–${fmt(b)}</span></div></div>`; }).join('') +
      `<div class="axis">${ticks.map(v => `<span style="left:${pct(v)}%">${v}</span>`).join('')}</div>`);
  });

  const fit = I('fit'); if (!fit || !M) return;
  // campos do modal = os do JSON; a chave na tabela é o id sem o "f", minúsculo (fPeito -> peito), ou c.k
  const KS = M.campos.map(c => c.k || c.id.replace(/^f/, '').toLowerCase()), EL = M.campos.map(c => I(c.id));
  const cap = TAM.length > 0 && !Array.isArray(TAM[0][KS[0]]);   // medida única por tamanho (capa): indica o menor que comporta
  const MED = KS.filter(k => TAM.length && !Array.isArray(TAM[0][k])), CONF = KS.find(k => TAM.length && Array.isArray(TAM[0][k]));

  // faixa: ok = um tamanho indicado · limite = entre dois, confirmar · nao = fora da tabela. v = { chave: número|null }
  // comporta: o menor tamanho em que todas as medidas únicas cabem; a faixa (peso) só confere
  function avalia(v) {
    const [k0, k1] = KS;
    if (cap) {
      const i = TAM.findIndex(s => MED.every(k => v[k] <= lim(s[k])));
      if (i < 0) return { n: 'nao', fora: 'maior', cabe: [] };
      const s = TAM[i], fora = !!(CONF && v[CONF] && !dentro(v[CONF], s[CONF]));
      return { n: fora ? 'limite' : 'ok', t: s.t, cabe: [s], pescFora: fora, menor: i === 0, desempate: i > 0 && MED.some(k => v[k] < lim(s[k])), semConf: !!CONF && !v[CONF] };
    }
    const cabe = TAM.filter(s => dentro(v[k0], s[k0]));
    if (!cabe.length) return { n: 'nao', fora: v[k0] < Math.min(...TAM.map(s => s[k0][0])) ? 'menor' : 'maior', cabe };
    if (cabe.length === 1) {
      const s = cabe[0], fora = !!(k1 && v[k1] && !dentro(v[k1], s[k1]));
      return { n: fora ? 'limite' : 'ok', t: s.t, cabe, pescFora: fora };
    }
    const porPesc = k1 && v[k1] ? cabe.filter(s => dentro(v[k1], s[k1])) : [];
    if (porPesc.length === 1) return { n: 'ok', t: porPesc[0].t, cabe, desempate: true };
    return { n: 'limite', cabe };
  }
  if (D.slug === 'peitoral') [[40, null, 'ok', 'S'], [43.5, null, 'limite'], [43.5, 35, 'ok', 'M'], [50, 41, 'ok', 'L'], [60, null, 'ok', 'XL'], [37, null, 'nao'], [63, null, 'nao'], [46, 25, 'limite']]
    .forEach(([p, c, n, t]) => { const r = avalia({ peito: p, pesc: c }); console.assert(r.n === n && (!t || r.t === t), 'avalia', p, c, r); });

  const res = I('fitRes'), lv = I('fitLv'), why = I('fitWhy'), wa = I('fitWa');
  const chart = $('[data-chart]', res);
  const num = (el) => { const s = el.value.trim().replace(',', '.'); const x = parseFloat(s); return s && isFinite(x) && x > 0 ? x : null; };
  const nomes = (cabe) => cabe.map(s => s.t).join(', ').replace(/, ([^,]*)$/, ' e $1');
  function titulo(r) {
    if (r.n === 'nao') return M.tit[r.fora];
    if (r.menor && M.tit.menor) return T0(M.tit.menor, r);
    if (r.n === 'ok') return T0(M.tit.ok, r);
    return r.t ? T0(M.tit.pesc, r) : T0(M.tit.entre, { n: nomes(r.cabe) });
  }
  function marca(valor, r) {
    if (!chart) return;
    $$('.sb', chart).forEach(b => {
      b.classList.toggle(C('on'), r && r.n !== 'nao' && (r.t ? b.dataset.t === r.t : r.cabe.some(s => s.t === b.dataset.t)));
      b.classList.toggle(C('dim'), !!r && !b.classList.contains(C('on')));
    });
    $$('.mk', chart).forEach(m => m.remove());
    if (!valor) return;
    $$('.trk', chart).forEach((t, i) => { const m = document.createElement('i'); m.className = C('mk'); m.style.left = pct(valor) + '%'; if (i === 0) m.dataset.v = fmt(valor) + ' ' + un; t.append(m); });
  }
  function update() {
    const val = {}; KS.forEach((k, i) => { val[k] = num(EL[i]); });
    const L = M.li, [k0, k1, k2] = KS;
    const linhas = () => M.campos.map((c, i) => `${c.label}: ${val[KS[i]] ? fmt(val[KS[i]]) + ' ' + c.un : 'não medi'}`).join('\n');
    const pronto = TAM.length && (cap ? MED.every(k => val[k]) : val[k0]);
    let msg = M.msg0;
    if (pronto) {
      const r = avalia(val), li = [], v = { p: fmt(val[k0]), c: k1 && val[k1] && fmt(val[k1]), w: k2 && val[k2] && fmt(val[k2]), t: r.t, n: nomes(r.cabe) };
      res.dataset.lv = r.n === 'ok' ? 'folga' : r.n;
      lv.textContent = titulo(r);
      li.push(T0(r.cabe.length ? L.faixa : L.peito, v));
      if (r.desempate) li.push(T0(L.desempate, v));
      if (r.pescFora) li.push(T0(L.fora, v));
      if (r.semConf) li.push(L.medir_pesc);
      if (r.n === 'limite' && !r.t) li.push(val[k1] ? L.sem_desempate : L.medir_pesc);
      if (r.n === 'nao') li.push(L[r.fora]);
      if (r.menor && L.menor) li.push(L.menor);
      why.innerHTML = li.filter(Boolean).map(t => `<li>${t}</li>`).join('');
      marca(G && val[G.k], r);
      msg = `${M.msg1}\n${linhas()}\n${M.msg_rot[M.msg_rot.length - 1]}: ${titulo(r)}`;
    } else {
      // sem tabela de medidas de cão (ou campo vazio): não calcula; pede o dado e encaminha ao WhatsApp
      delete res.dataset.lv; lv.textContent = M.res0;
      why.innerHTML = `<li>${M.why0}</li>`; marca(null, null);
      if (!TAM.length && KS.some(k => val[k])) msg = `${M.msg1}\n${linhas()}`;
    }
    wa.href = `https://wa.me/${D.whatsapp}?text=${encodeURIComponent(msg)}`;
  }
  EL.forEach(el => el.addEventListener('input', update));
  I('fitForm').addEventListener('submit', e => e.preventDefault());
  let fitFrom = null;
  $$('[data-fit]').forEach(b => b.addEventListener('click', () => { fitFrom = b; update(); fit.showModal(); I('fitH').focus(); }));   // foco no título: nenhum campo abre o teclado sozinho
  I('fitClose').onclick = () => fit.close();
  fit.addEventListener('click', e => { if (e.target === fit) fit.close(); });
  fit.addEventListener('close', () => fitFrom && fitFrom.focus());
  fit.addEventListener('keydown', e => {   // foco preso
    if (e.key !== 'Tab') return;
    const f = [...fit.querySelectorAll('button,input,a[href]')].filter(x => x.offsetParent && x.tabIndex >= 0);
    const a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });
  window.__fit = avalia; // usado pelo teste de aceite
})();

})();
